import API from '../api'
import getUrl from './paths'
import convertPagableData from '../convertPagableData'

export const getAllApprovalMetrics = ({ page = 0, size = 10, status = null, type = null }) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getApprovalMetrics, { page, size, status, type })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((err) => reject(err))
	})

// filters: { referenceId, status, enquiryStatus, buyerOrg, supplierOrg, rmUserId, platform }; empty keys are dropped
const serializeFilters = (filters) => {
	const applied = Object.entries(filters || {}).reduce((acc, [key, val]) => {
		if (val !== null && val !== undefined && val !== '') acc[key] = val
		return acc
	}, {})
	return Object.keys(applied).length ? JSON.stringify(applied) : null
}

export const getApprovalEnquirySummary = ({ page = 0, size = 5, status = null, type = null, enquiryStatus = null, filters = null }) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getApprovalEnquirySummary, { page, size, status, type, enquiryStatus, filters: serializeFilters(filters) })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((err) => reject(err))
	})

export const getUserCreditSummary = (organisationId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getUserCreditSummary, { organisationId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const getOverdueInvoices = (organisationId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getOverdueInvoices, { organisationId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const getApprovalMessages = (creditApprovalId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getApprovalMessages, { creditApprovalId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const getApprovalsOfEnquiry = (referenceId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getApprovalsByReferenceId, { referenceId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})
